import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import { mergeIds, compressAndFilter, compactAndFilter } from '@/utils'

const defaultParams = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().add(30, 'days').format('YYYY-MM-DD'),
}
const module = 'faces'
let doc = {
  list: {
    name: 'Disponibilités',
    hasMap: true,
    headers: [
      { label: 'Code', value: 'full_code' },
      { label: 'Type', value: 'board.board_type.name' },
      { label: 'Adresse', value: 'board.adress' },
      { label: 'District', value: 'board.district.name' },
      { label: 'Ville', value: 'board.district.city.name' },
      { label: 'Region', value: 'board.district.city.region.name' },
      { label: 'Du', value: 'from', orig: 'date_free_from', inDetail: false },
      { label: 'Au', value: 'to', orig: 'date_free_to', inDetail: false },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', isFlat: false, dispatch: `${module}/goTo` },
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md6' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md6' },
      { label: 'Région', type: 'multilist', name: 'region_id', from: 'name', source: 'regions', classes: 'md4' },
      { label: 'Ville', type: 'multilist', name: 'city_id', from: 'name', source: 'cities', classes: 'md4' },
      { label: 'District', type: 'multilist', name: 'district_id', from: 'name', source: 'districts', classes: 'md4' },
      { label: 'Type', type: 'multilist', name: 'type_id', from: 'name', source: 'boardtypes', classes: 'md4' },
    ],
    selectActions: [
      {
        label: 'Rapport',
        icon: 'assignment',
        dispatch: `${module}/report`,
      },
    ],
  },

  form: {
    name: 'Face',
    hasPhoto: true,
    actions: [
      {
        icon: 'pie_chart',
        isFlat: true,
        context: {field: 'id'},
        dispatch: `tenancy/getTenancy`,
      },
      {
        icon: 'save',
        filter: {edit: true},
        scope: ['faces.update'],
        dispatch: `${module}/update`,
      },
      {
        icon: 'delete',
        scope: ['faces.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    fields: [
      { label: 'Code', type: 'code', name: 'code' },
      { label: 'Coté', type: 'list', from: 'name', name: 'board_side_id', source: 'boardsides' },
    ],
    relations: [
      {
        name: 'Réservations',
        source: 'bookings',
        headers: [
          { label: 'Nom', value: 'basket.name' },
          { label: 'Client', value: 'basket.client.name' },
          { label: 'Début', value: 'dateStart', orig: 'basket.date_start', card: false },
          { label: 'Fin', value: 'dateEnd', orig: 'basket.date_end', card: false },
          { label: 'Dates', value: 'dates', sortable: false, inTable: false },
          { label: 'Status', value: 'basket.status.name' },
        ],
        dispatch: 'getBookings',
      },
      {
        name: 'Affichages',
        source: 'displays',
        headers: [
          { label: 'Campagne', value: 'campaign.visual.name' },
          { label: 'Client', value: 'campaign.visual.client.name' },
          { label: 'Affiché le', value: 'dateUp' },
          { label: 'Par', value: 'user.username' },
          { label: 'Désaffiché le', value: 'dateDown' },
        ],
        dispatch: 'getDisplays',
        dataActions: [
          { icon: 'visibility', isFlat: false, scope: ['displays.read'], dispatch: `displays/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {},
    fetchOne: {
      include: 'board_side,board.board_type,board.district.city.region',
      ...defaultParams,
    },
  },

  postprocess: item => ({
    position: item.board ? {lng: parseFloat(item.board.lon), lat: parseFloat(item.board.lat)} : undefined,
    ...item,
    from: item.date_free_from ? moment(item.date_free_from).format('DD/MM/YYYY') : '',
    to: item.date_free_to ? moment(item.date_free_to).format('DD/MM/YYYY') : '',
  }),
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  state: {
    search: {
      data: defaultParams,
    },
  },
  actions: {
    getDisplays: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('displays/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        face_id: context.id,
        include: 'campaign.visual.client,user,face.board',
      }
      apiClient.fetchCustom('displays', `displays/list`, params)
        .then(data => {
          commit('displays/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          console.log(error)
          commit('displays/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    getBookings: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('bookings/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        face_id: context.id,
        include: 'face,basket.client,basket.status',
      }
      apiClient.fetchCustom('bookings', `bookings/list`, params)
        .then(data => {
          commit('bookings/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('bookings/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
    report: ({ commit }, payload) => {
      const { data, context } = payload
      commit('EXPORT_REQUEST', payload)
      commit('SET_LOADING', true)
      const contextParams = context.params ? context.params : {}
      const params = {id: mergeIds(data), ...contextParams}
      let cleaned = compressAndFilter(params)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download('faces', `reports/available`, {}, cleaned, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
          commit('SET_LOADING', false)
        })
    },
  },
}
export default merge(base, custom)
